import React from "react";
import styled from "styled-components";
import StrongTestBg from "../../assets/card-bg-strong.png";
import WeakTestBg from "../../assets/card-bg-weak.png";
import NoTestBg from "../../assets/window-notest-bg.png";

const StyledImg = styled.img`
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  width: 100%;
  border-top-right-radius: 40px;
  border-top-left-radius: 40px;
  display: inline-block;
`;

const TestCardBackground = (props) => {
  return (
    <>
      {props.strong && (
        <StyledImg
          className="ui image"
          alt="SafeFun"
          src={StrongTestBg}
        ></StyledImg>
      )}

      {props.weak && !props.strong ? (
        <StyledImg
          className="ui image"
          alt="SafeFun"
          src={WeakTestBg}
        ></StyledImg>
      ) : null}

      {!props.strong && !props.weak ? (
        <StyledImg
          className="ui image"
          alt="SafeFun"
          src={NoTestBg}
        ></StyledImg>
      ) : null}
    </>
  );
};

export default TestCardBackground;
